import { render } from "./LbrxLoaderPopup.vue?vue&type=template&id=c2e2f5a8&scoped=true"
import script from "./LbrxLoaderPopup.vue?vue&type=script&lang=js"
export * from "./LbrxLoaderPopup.vue?vue&type=script&lang=js"

import "./LbrxLoaderPopup.vue?vue&type=style&index=0&id=c2e2f5a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2e2f5a8"]])

export default __exports__